module.exports = __webpack_public_path__ + "static/media/activity_feed.85cc0e7e.png";